
      <div class="group-filter fade-in-animation">
          <div ngbDropdown class="d-inline-block" #myDrop="ngbDropdown">
              <div class="btn btn-outline-primary" id="dropdownGroups" ngbDropdownToggle>
                  <div class="dropdown-label">Grupo</div>
                  <div class="selected-items" *ngIf="!selectedGroups.length">Todos</div>
                  <div class="selected-items" *ngIf="selectedGroups.length">
                      {{selectedGroups.length}} {{selectedGroups.length > 1 ? 'grupos selecionados' : 'grupo selecionado'}}
                  </div>
              </div>

              <ul ngbDropdownMenu aria-labelledby="dropdownGroups">
                  <li class="colab-checkbox"
                      *ngFor="let group of groups" [class.disabled]="selectedGroups.includes('all')"
                      (click)="onGroupSelect(group.id)">
                      <input type="checkbox"
                             [checked]="selectedGroups.includes(group.id)"
                             [value]="group.id"
                             [id]="group.id"
                             [name]="group.name">
                      <label [for]="group.id" (click)="onGroupSelect(group.id)">{{group.name}}</label>
                  </li>
              </ul>
          </div>
      </div>
  